import React from 'react';
import PropTypes from 'prop-types';
import d3, { useD3 } from 'hooks/useD3';
import * as topojson from 'topojson-client';
import mississippiGeoData from '../ChoroplethMap/ms.json';

const CountyFromState = ({
  countyName = '',
  color = '#ff7c09',
  size = 100,
  id = 'CountyFromState',
}) => {
  const ref = useD3(
    (svg) => {
      const width = size;
      const height = size;
      svg.selectAll('*').remove();
      svg.attr('width', width).attr('height', height);
      const topology = topojson.feature(mississippiGeoData, mississippiGeoData.objects.counties);
      let found = false;

      // Find the county in the state map
      topology.features = topology.features.filter(function (d) {
        found = true;
        return d.properties.name === countyName;
      });

      const projection = d3.geoMercator().translate([width / 2, height / 2]);
      const bounds = d3.geoBounds(topology);
      const center = d3.geoCentroid(topology);
      const distance = d3.geoDistance(bounds[0], bounds[1]);
      const scale = height / distance / Math.sqrt(2);
      projection.scale(scale).center(center);

      if (found) {
        // Draw the map
        svg
          .append('g')
          .selectAll('path')
          .data(topology.features)
          .enter()
          .append('path')
          .attr('fill', color)
          .attr('d', d3.geoPath().projection(projection))
          .style('stroke', 'none');
      }
    },
    [countyName, color],
  );
  return <svg ref={ref} id={id} />;
};

CountyFromState.propTypes = {
  countyName: PropTypes.string,
  size: PropTypes.number,
  color: PropTypes.string,
  id: PropTypes.string.isRequired,
};

export default React.memo(CountyFromState);
